export const reAddressConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_ADDRESS_SUCCESS',
		REQUEST : 'GET_PAGED_ADDRESS_REQUEST',
		FAILURE : 'GET_PAGED_ADDRESS_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_ADDRESS_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_ADDRESS_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_ADDRESS_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_ADDRESS_REQUEST',
		SUCCESS : 'CREATE_ADDRESS_SUCCESS',
		FAILURE : 'CREATE_ADDRESS_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_ADDRESS_REQUEST',
		SUCCESS : 'DELETE_ADDRESS_SUCCESS',
		FAILURE : 'DELETE_ADDRESS_FAILURE'
	},

	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_ADDRESS_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_ADDRESS_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_ADDRESS_FAILURE'
	},

	Update: {
		REQUEST : 'UPDATE_ADDRESS_REQUEST',
		SUCCESS : 'UPDATE_ADDRESS_SUCCESS',
		FAILURE : 'UPDATE_ADDRESS_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_ADDRESS_REQUEST',
		SUCCESS : 'RESTORE_ADDRESS_SUCCESS',
		FAILURE : 'RESTORE_ADDRESS_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_ADDRESSES_REQUEST',
		SUCCESS : 'GET_LIST_ADDRESSES_SUCCESS',
		FAILURE : 'GET_LIST_ADDRESSES_FAILURE'
	},
	CLEAR: 'CLEAR_ADDRESS'
}